/* eslint-disable camelcase */
import { parseFrequency } from './api';

/**
 * Converst the current redux state to purchase
 * post compatible json
 */
export const getProductsForPurchasePost = (state = {}, productIds = []) =>
  (state.optedin || [])
    .map(optin => ({
      product: optin.id,
      subscription_info: {
        components: optin.components || []
      },
      tracking_override: {
        offer: ((state.productOffer || {})[optin.id] || [])[0],
        ...parseFrequency(optin.frequency)
      }
    }))
    .filter(optin => optin['tracking_override'].offer)
    .filter(optin => (productIds.length ? productIds.includes(optin.product) : optin));

export default { getProductsForPurchasePost };
